/* eslint-disable react/jsx-no-useless-fragment */
import React, { Fragment } from 'react';

import { IMessage, MessageType } from './types';
import { LinkMessage } from './LinkMessage';
import { JumpLinkMessage } from './JumpLinkMessage';
import { UserMentionMessage } from './UserMentionMessage';
import { TextMessage } from './TextMessage';
import { messageSplitter } from './messageHelperFunctions';
import { IMessageDrawerOptions } from '../globalInterfaces/globalInterfaces';

interface ISlMessageDrawerProps {
    message: string;
    userMentionClass?: string;
    linkClass?: string;
    options?: IMessageDrawerOptions;
    callbacks?: {
        handleJumpLinkClick?: (text: string, link: string) => void;
    };
}

export function SlMessageDrawer({
	message,
	userMentionClass = '',
	linkClass = '',
	options = {
		enableJumpLink: false,
		enableLinkMessage: true,
		enableUserMention: true,
	},
	callbacks = {},
}: ISlMessageDrawerProps): JSX.Element {
	const messagesByTypes = messageSplitter(message, options);

	const renderMessage = (m: IMessage): JSX.Element => {
		if (m.type === MessageType.link) {
			return <LinkMessage message={m} className={linkClass} />;
		}

		if (m.type === MessageType.userMention) {
			return (
				<UserMentionMessage message={m} className={userMentionClass} />
			);
		}

		if (m.type === MessageType.jumpLink) {
			return (
				<JumpLinkMessage
					message={m}
					onClick={callbacks.handleJumpLinkClick}
				/>
			);
		}

		return <TextMessage message={m} />;
	};

	return (
		<>
			{Array.isArray(messagesByTypes)
                && messagesByTypes.map((m) => <Fragment key={m.id}>{renderMessage(m)}</Fragment>)}
		</>
	);
}
